const SCROLL_THRESHOLD = 50;
const TIME_THRESHOLD = 30;
const MIN_VISIT_DAYS = 1;
const DISMISS_COOLDOWN = 7;
const STORAGE_KEY = 'ftg_premium_popup';
const SESSION_KEY = 'ftg_premium_popup_shown';
const EXCLUDED_PATHS = ['/premium', '/login', '/register', '/checkout', '/password'];

function getStorageData() {
    try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {
            visitDays: [],
            dismissedUntil: null
        };
    } catch {
        return { visitDays: [], dismissCount: 0, dismissedUntil: null };
    }
}

function saveStorageData(data) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
}

function todayString() {
    return new Date().toISOString().slice(0, 10);
}

window.premiumPopup = function () {
    return {
        scrollMet: false,
        timeMet: false,
        tracking: false,

        init() {
            const data = getStorageData();
            const today = todayString();

            if (!data.visitDays.includes(today)) {
                data.visitDays.push(today);
                saveStorageData(data);
            }

            if (this.shouldAbort(data)) return;

            this.tracking = true;
            this.trackEngagement();
        },

        shouldAbort(data) {
            if (EXCLUDED_PATHS.some(p => window.location.pathname.startsWith(p))) return true;
            if (sessionStorage.getItem(SESSION_KEY)) return true;
            if (data.visitDays.length < MIN_VISIT_DAYS) return true;
            if (data.dismissedUntil && new Date(data.dismissedUntil) > new Date()) return true;
            return false;
        },

        trackEngagement() {
            const scrollableDistance = document.documentElement.scrollHeight - window.innerHeight;
            if (scrollableDistance <= 0) {
                this.scrollMet = true;
            } else {
                let ticking = false;
                const onScroll = () => {
                    if (this.scrollMet) return;
                    if (!ticking) {
                        requestAnimationFrame(() => {
                            const scrolled = (window.scrollY / scrollableDistance) * 100;
                            if (scrolled >= SCROLL_THRESHOLD) {
                                this.scrollMet = true;
                                window.removeEventListener('scroll', onScroll);
                                this.maybeShow();
                            }
                            ticking = false;
                        });
                        ticking = true;
                    }
                };
                window.addEventListener('scroll', onScroll, { passive: true });
            }

            setTimeout(() => {
                this.timeMet = true;
                this.maybeShow();
            }, TIME_THRESHOLD * 1000);
        },

        maybeShow() {
            if (!this.scrollMet || !this.timeMet) return;
            this.show();
        },

        show() {
            sessionStorage.setItem(SESSION_KEY, '1');
            $('#premiumPopupModal').modal('show');
        },

        dismiss() {
            const data = getStorageData();
            const until = new Date();
            until.setDate(until.getDate() + DISMISS_COOLDOWN);

            data.dismissedUntil = until.toISOString().slice(0, 10);
            saveStorageData(data);

            $('#premiumPopupModal').modal('hide');
        }
    };
};

window.showPremiumPopup = function () {
    $('#premiumPopupModal').modal('show');
};
